import { BaseQConfigGeneratorResultList, type QConfigGeneratorResult } from '../../components';

interface QConfigGeneratorResultProps {
  rows: QConfigGeneratorResult[];
}
export default function QConfigGeneratorResultList(props: Readonly<QConfigGeneratorResultProps>) {
  const { rows } = props;

  return <BaseQConfigGeneratorResultList rows={rows} />;
}
